<template>
  <div class="card mt-3 mb-3 ns-resume">
    <div class="card-header">{{ catalogueTraduction?.formResumeTitre || $t('form.resume.titre') }}</div>
    <div class="card-body">

      <div v-if="booking.avantages" v-html="activity.beneficierAvantage" />
      <div v-else-if="activity.validationAutomatique && activity.reductionMC" v-html="activity.beneficierPasAvantage" />

      <ul class="list-group list-group-flush">
        <template v-for="(value, name) in booking" :key="name">
          <li v-if="value
          && name !== 'id'
          && name !== 'activite'
          && name !== 'adresse'
          && name !== 'periodes'
          && name !== 'contingents'
          && name !== 'questions'
          && name !== 'documents'
          && name !== 'urgence'
          && name !== 'facturation'
          && name !== 'embarquement'
          && name !== 'debarquement'
          && name !== 'contingents'
          && name !== 'prix'
          && name !== 'conditions'
          && name !== 'contenuPromotionnel'
          && name !== 'facturationIdentique'
          && name !== 'urgenceIdentique'
          && name !== 'urgenceTelephonePrefix'
          && name !== 'telephonePrefix'
          && name !== 'telPrefix'
          && name !== 'mobilePrefix'" class="list-group-item">
            <strong>
              <template v-if="name.startsWith('urgence')">
                {{ name.substring(7).toUpperCase() }} d'{{ name.substring(0,7).toUpperCase() }}
              </template>
              <template v-else>
                {{ name.toUpperCase() }}
              </template>
              &nbsp;:&nbsp;
            </strong>
            <span v-if="value === true">OUI</span>
            <span v-else-if="value === false">NON</span>
            <span v-else-if="name === 'urgenceTelephone'">{{booking.urgenceTelephonePrefix}} {{value}}</span>
            <span v-else-if="name === 'telephone'">{{booking.telephonePrefix}} {{value}}</span>
            <span v-else-if="name === 'mobile'">{{booking.mobilePrefix}} {{value}}</span>
            <span v-else>{{value}}</span>
          </li>
          <!-- Adresses -->
          <li v-else-if="name === 'adresse' && booking.adresse.cp" class="list-group-item">
            <strong>{{ name.toUpperCase() }}&nbsp;:&nbsp;</strong>
            <ul class="list-group-flush">
              <template v-for="(field, property) in value" :key="property">
                <li v-if="property === 'rue'" class="list-group-item">
                  {{value.rue}}
                  <template v-if="value.numero">&nbsp;{{value.numero}}</template>
                  <template v-if="value.boite">/{{value.boite}}</template>
                </li>
                <li v-if="property === 'cp'" class="list-group-item">
                  {{value.cp}}
                  <template v-if="value.ville">&nbsp;{{value.ville}}</template>
                </li>
                <li v-if="field && property !== 'bosa' && property !== 'rue' && property !== 'numero'
                      && property !== 'boite' && property !== 'cp' && property !== 'ville'
                      && property !== 'telPrefix' && property !== 'mobilePrefix' "
                    class="list-group-item">
                  <template v-if="property === 'tel'">
                    {{value.telPrefix}}&nbsp;{{field}}
                  </template>
                  <template v-else-if="property === 'mobile'">
                    {{value.mobilePrefix}}&nbsp;{{field}}
                  </template>
                  <template v-else>
                    {{ field }}
                  </template>
                </li>
              </template>
            </ul>
          </li>
          <li v-else-if="name === 'facturation' && !booking.facturationIdentique && booking.facturation.cp" class="list-group-item">
            <strong>{{ name.toUpperCase() }}&nbsp;:&nbsp;</strong>
            <ul class="list-group-flush">
              <template v-for="(field, property) in value" :key="property">
                <li v-if="property === 'rue'" class="list-group-item">
                  {{value.rue}}
                  <template v-if="value.numero">&nbsp;{{value.numero}}</template>
                  <template v-if="value.boite">/{{value.boite}}</template>
                </li>
                <li v-if="property === 'cp'" class="list-group-item">
                  {{value.cp}}
                  <template v-if="value.ville">&nbsp;{{value.ville}}</template>
                </li>
                <li v-if="field && property !== 'bosa' && property !== 'rue' && property !== 'numero' && property !== 'boite' && property !== 'cp' && property !== 'ville'"
                    class="list-group-item">{{ field }}</li>
              </template>
            </ul>
          </li>
          <li v-else-if="name === 'urgence' && !booking.urgenceIdentique" class="list-group-item">
            <strong>{{ name.toUpperCase() }}&nbsp;:&nbsp;</strong>
            <ul class="list-group-flush">
              <template v-for="(field, property) in value" :key="property">
                <li v-if="field" class="list-group-item">{{ field }}</li>
              </template>
            </ul>
          </li>
          <!-- Périodes -->
          <li v-else-if="name === 'periodes' && booking.periodes?.length > 0 && booking.periodes?.filter(p => p?.checked && !p?.prix).length > 0" class="list-group-item">
            <strong>{{ name.toUpperCase() }}&nbsp;:&nbsp;</strong>
            <ul class="list-group-flush">
              <template v-for="(periode, property) in value" :key="property.id">
                <li v-if="periode.checked && !periode.prix" class="list-group-item">{{ periode.texte }}</li>
              </template>
            </ul>
          </li>
          <!-- Questions -->
          <li v-else-if="name === 'questions' && booking.questions?.length > 0 && booking.questions?.filter(q => q?.valeur).length > 0" class="list-group-item">
            <strong>{{ name.toUpperCase() }}&nbsp;:&nbsp;</strong>
            <ul class="list-group-flush">
              <template v-for="(question, property) in value" :key="property.id">
                <li v-if="question.valeur" class="list-group-item">
                  <strong>{{ question.texte }}&nbsp;:&nbsp;</strong>
                  {{ question.valeur }}
                </li>
              </template>
            </ul>
          </li>
          <!-- Contingents -->
          <li v-else-if="name === 'contingents' && booking.contingents?.length > 0 && booking.contingents?.filter(c => c?.checked && c?.type === constants.inscription.CONTINGENT_NORMAL).length > 0" class="list-group-item">
            <strong>{{ catalogueTraduction?.formContingents || $t('form.contingents') }}&nbsp;:&nbsp;</strong>
            <ul class="list-group-flush">
              <template v-for="contingent in booking.contingents?.filter(c => c?.checked && c?.type === constants.inscription.CONTINGENT_NORMAL)" :key="contingent.id">
                <li class="list-group-item">{{ contingent.texte }}</li>
              </template>
            </ul>
          </li>
          <!-- Embarquement -->
          <li v-else-if="name === 'embarquement' && booking.embarquement?.id" class="list-group-item">
            <strong>{{ name.toUpperCase() }}&nbsp;:&nbsp;</strong>
            {{ value.texte }}
          </li>
          <!-- Débarquement -->
          <li v-else-if="name === 'debarquement' && booking.debarquement?.id" class="list-group-item">
            <strong>{{ name.toUpperCase() }}&nbsp;:&nbsp;</strong>
            {{ value.texte }}
          </li>
        </template>
      </ul>

      <div v-if="booking.prix && booking.prix > 0" class="alert alert-secondary mt-3" role="alert">
        <!-- Périodes payantes -->
        <template v-if="booking.periodes?.length > 0 && booking.periodes?.filter(p => p?.checked && p?.prix).length > 0">
          <div v-for="periode in booking.periodes.filter(p => p.checked && p.prix)" :key="periode.id">
            <strong>{{ periode.texte }}&nbsp;:&nbsp;</strong>
            <span class="badge bg-secondary rounded-pill">{{ formatPrice(periode.prix) }}<small>&nbsp;€</small></span>
            <div v-if="periode.garderie">
              {{ catalogueTraduction?.formPeriodesGarderie || $t('form.periodes.garderie') }}
              <span class="badge bg-secondary rounded-pill">{{ formatPrice(periode.prixGarderie) }}<small>&nbsp;€</small></span>
            </div>
            <div v-if="periode.transport">
              {{ catalogueTraduction?.formPeriodesTransport || $t('form.periodes.transport') }}
              <span class="badge bg-secondary rounded-pill">{{ formatPrice(periode.prixTransport) }}<small>&nbsp;€</small></span>
            </div>
          </div>
        </template>
        <!-- Contingents payants ou réduction -->
        <template v-if="booking.contingents?.length > 0 && booking.contingents?.filter(c => c?.checked).length > 0">
          <div v-for="contingent in booking.contingents.filter(c => c?.checked && c.type === constants.inscription.CONTINGENT_PAYANT)" :key="contingent.id">
            <strong>{{ contingent.texte }}</strong><small>{{ $t(getLibelleForTypePaiement(contingent.typePaiement)) }}</small>
            <span v-if="contingent.prix" class="badge bg-secondary rounded-pill ms-2">{{ formatPrice(contingent.prix) }}
              <small>€</small></span>
          </div>
          <div v-for="contingent in booking.contingents.filter(c => c?.checked && c.type === constants.inscription.CONTINGENT_REDUCTION)" :key="contingent.id">
            <strong>{{ contingent.texte }}</strong><small>{{ $t(getLibelleForTypePaiement(contingent.typePaiement)) }}</small>
            <span v-if="contingent.prix && contingent.type === constants.inscription.CONTINGENT_REDUCTION"
                  class="badge bg-success rounded-pill ms-2">-&nbsp;{{ formatPrice(contingent.prix) }}
              <small>€</small></span>
          </div>
        </template>

        <h5 class="mt-3 total">
          <i class="bi-basket"></i>&nbsp;
          <strong>{{ catalogueTraduction?.formPrixTotal || $t('form.prixTotal') }}</strong>
          <span class="fw-bold badge bg-secondary">{{ formatPrice(booking.prix) }}<small>&nbsp;€</small></span>
        </h5>
      </div>
    </div>
  </div>
</template>

<script>
import {useStore} from "vuex";
import {onBeforeMount, onBeforeUnmount, ref} from "vue";
import constants from "@/constants";
import {onBeforeRouteLeave} from "vue-router";
import {formatPrice} from "@/utils";

export default {
  name: "BookingSummary",
  props: ['typeActivite', 'leave', 'activity', 'catalogueTraduction'],
  setup(props) {
    const store = useStore();
    const booking = ref(store.getters.getBooking);

    const preventNav = (e) => {
      e.preventDefault();
      e.returnValue = "";
    };

    onBeforeMount(() => {
      window.addEventListener("beforeunload", preventNav);
    });

    onBeforeUnmount(() => {
      window.removeEventListener("beforeunload", preventNav);
    });

    onBeforeRouteLeave((to, from, next) => {
      if (!props.leave && !window.confirm(this.catalogueTraduction?.formConfirmationQuitterPageResumeInscripton || "Quitter la page? Attention, Vous devez valider votre inscription sinon celle-ci ne sera pas prise en compte."))
        return;
      next();
    });

    const getLibelleForTypePaiement = ((typePaiement) => {
      let libelle = 'global.vide';

      if(!(props.typeActivite === constants.inscription.TYPE_ACTIVITE_PLAINE))
        return libelle;

      if (typePaiement === constants.inscription.PRIX_PAR_JOUR)
        libelle = this.catalogueTraduction?.formPaiementParJour ? this.catalogueTraduction?.formPaiementParJour : 'form.paiement.parJour';
      else if (typePaiement === constants.inscription.PRIX_PAR_PERIODE)
        libelle = this.catalogueTraduction?.formPaiementParPeriode ? this.catalogueTraduction?.formPaiementParPeriode : 'form.paiement.parPeriode';


      return libelle;
    });

    return {booking, constants, getLibelleForTypePaiement, formatPrice};
  }
}
</script>

<style scoped>

</style>
